import React from 'react';

import classNames from 'classnames';

const CATEGORY_CLASSES = {
    not_started: 'tw-bg-charcoal-10 tw-text-charcoal-75',
    in_market: 'tw-bg-blue-10 tw-text-blue',
    offer_stage: 'tw-bg-amber-100 tw-text-amber-800',
    filled: 'tw-bg-green-25 tw-text-dark-green',
};

/** A recruitment category as a small coloured pill. */
export default function RecruitmentCategoryPill({ category, label }) {
    return (
        <span
            className={classNames(
                'tw-inline-block tw-rounded-full tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium',
                CATEGORY_CLASSES[category] ?? CATEGORY_CLASSES.not_started,
            )}
        >
            {label}
        </span>
    );
}
